module.exports = __webpack_public_path__ + "static/scale-model-of-eastern-states-exposition-in-springfield-massachusetts-3d71605cf754b7aa1ba82def7e102fa6.png";